module.exports = __webpack_public_path__ + "5b04988c47fbab73248244dd66f1455e.jpg";